<template>
  <div :class="['import-file', 'mt-4']" :id="id">
    <label>
      <div :class="['button', 'block', 'cursor-pointer']" :title="lang.importLocalData">
        <icon name="folder-open" /><span v-html="lang.importImageOrData" />
      </div>
      <input type="file" @change="getFileData" :accept="mimeTypes.join(',')" />
    </label>
  </div>
</template>
<script>
import lang from '../helpers/lang'
import events from '../helpers/events'
import mimeTypes from '../helpers/mime-types'

export default {
  name: 'ImportFile',
  data () {
    return {
      lang,
      mimeTypes,
      id: 'import-file'
    }
  },
  methods: {
    /**
     * Get the file data from the file input
     * @method getFileData
     * @return {void}
     */
    getFileData () {
      this.file = this.getFileInput()
      this.getBase64()
    },
    /**
     * Check if the imported data is JSON or image
     * @method isJsonData
     * @return {boolean}
     */
    isJsonData (type = null) {
      if (type) {
        const mimeTypes = this.mimeTypes
        return [mimeTypes[4], mimeTypes[5]].includes(type)
      }
    },
    /**
     * Get the file input node data
     * @method getFileInput
     * @return {array}
     */
    getFileInput () {
      return document.querySelector(`#${this.id} input`).files[0]
    },
    /**
     * Get the file data
     * @method getBase64
     * @return {void}
     */
    getBase64 () {
      const reader = new FileReader()
      const mimeTypes = this.mimeTypes
      const type = this.file.type
      if (!this.mimeTypes.includes(type)) {
        this.$root.$emit(events.error, {
          message: this.lang.fileTypeNotSupported(type, mimeTypes)
        })
        return
      }
      if (!this.isJsonData(type)) {
        reader.readAsDataURL(this.file)
      } else {
        reader.readAsText(this.file)
      }
      reader.onload = () => {
        this.file.result = reader.result
        const isJsonData = this.isJsonData(type)
        let result = this.file.result
        if (!isJsonData) {
          this.originalFile = result
        } else {
          result = JSON.parse(result)
          if (!result.cssHdr ||
            !result.cssHdr.length ||
            !result.cssHdr[0].width ||
            !result.cssHdr[0].height ||
            !result.cssHdr[0].url ||
            !result.cssHdr[0].mixBlendMode ||
            !result.cssHdr[0].index ||
            !result.cssHdr[0].filters) {
            this.$root.$emit(events.error, {
              message: this.lang.errorMessageJson
            })
            return
          }
        }
        this.$root.$emit(events.dataImported, {
          data: result,
          type: isJsonData ? 'json' : 'image'
        })
      }
      reader.onerror = (error) => {
        this.$root.$emit(events.error, {
          message: error
        })
      }
    }
  }
}
</script>
<style>
.import-file label
{
  display: block;
}

.import-file input
{
  position: absolute;
  clip: rect(0 0 0 0);
}
</style>



// WEBPACK FOOTER //
// src/components/import-file.vue